import { Component, HostBinding, input, output } from '@angular/core';
import { UmssIconComponent } from '../../components/icon/icon.component';
import { UmssButtonComponent } from './../button/button.component';

@Component({
  selector: 'umss-empty-state',
  imports: [UmssIconComponent, UmssButtonComponent],
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.scss'
})
export class UmssEmptyStateComponent {
  @HostBinding('style.display') display = 'contents';

  showIcon = input<boolean>(true);
  iconName = input<string | undefined>(undefined);
  title = input<string | undefined>(undefined);
  description = input<string | undefined>(undefined);

  showButton = input<boolean>(true);
  buttonLabel = input<string>('Reload filters');
  buttonVariant = input<
    'Primary' | 'Secondary' | 'Destructive' | 'Ghost' | 'Outline'
  >('Secondary');
  buttonLeftIconName = input<string | undefined>(
    'phosphorArrowCounterClockwise'
  );
  buttonRightIconName = input<string | undefined>(undefined);
  buttonClick = output<void>();

  hideBorder = input<boolean>(false);
}
